module.exports = __webpack_public_path__ + "static/img/banner-eng.0f99ca4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/banner-eng.png
// module id = ACuS
// module chunks = 0